import { isNotEmpty } from '@dte/otw-utils-core/src/objects/isEmpty';
import type { ReportAnswers } from '../../../../report/CustomerReport';
import { getSelectedAnswerStrings } from '../../../../report/getQuestion';
import { ReportQuestion } from '../../../../report/questions/ReportQuestion';

export function isEmergencyIssue(answers: ReportAnswers): boolean {
	const emergencyIssues = getSelectedAnswerStrings(answers, ReportQuestion.Emergencies);
	if (isNotEmpty(emergencyIssues)) {
		return true;
	}

	// TODO: return undefined if question not answered?
	return false;
}
